import MenuBar from "../components/MenuBar";
import { activateFullScreenPrompt } from "../redux/fullScreenPromptSlice";
import { useAppDispatch, useAppSelector } from "../redux/hook";
import { getPagedSherlockData, getSherlockMetrics } from "../service/apiAccessLogic";
import PageNotAccessable from "./PageNotAccessable";
import { msalInstance } from "../index"
import { setLastMonthIOCsRank, setLastWeekIOCsRank, setPagedIOCs, setPagedSightings, setSherlockDailyMetrics, setSherlockTotalCounts, setSherlockWeeklyMetrics, setStreamSightings } from "../redux/sherlockSlice";
import Theme from "../Theme"
import SherlockBackground from '../resource/DEFEND-Main-Services.jpg'
import SightingsLayout from "../components/sherlock/sightings/SightingsLayout";
import * as signalR from "@microsoft/signalr"
import { useEffect, useState } from "react";
import { Sighting } from "../models/SherlockModel";
import IOCLayout from "../components/sherlock/iocs/IOCLayout";

const SherlockPage = () => {
    const sherlockSubId = useAppSelector(state => state.user.sherlockId)
    const sightings = useAppSelector(state => state.sherlock.pagedSightings)
    const iocs = useAppSelector(state => state.sherlock.pagedIOCs)
    const activeTab = useAppSelector(state => state.sherlock.sherlockActiveTab)
    const dispatch = useAppDispatch()

    const signalRBaseUrl = process.env.REACT_APP_BACKEND_URL + "/api/?hub=sightings"
    const backendClientScope = "api://" + process.env.REACT_APP_BACKEND_APP_ID + "/saturn_user_impersonation"
    const connectionMethod = useAppSelector(state => state.user.sherlockWebsocketMethod)
    
    useEffect(() => {
        var tokenRequest = {
            account: msalInstance.getAllAccounts()[0],
            scopes: [backendClientScope]
        };
        msalInstance.acquireTokenSilent(tokenRequest)
            .then(response => {
                const token = response.accessToken

                const connection = new signalR.HubConnectionBuilder()
                    .withUrl(signalRBaseUrl, {
                        accessTokenFactory: () => token
                    })
                    .build()
                
                // connectionMethod is an array, and can contain multiple methods
                // we need to register all of them
                connectionMethod.forEach(method => {
                    connection.on(method, (sighting: Sighting) => {
                        dispatch(setStreamSightings(sighting))
                    })
                })

                connection.start().catch(err => console.error("Failed to connect to SignalR"))
                return () => {
                    connection.stop()
                }
            })
            .catch(err => { console.error("Failed to acquire token silently", err) })
    }, [connectionMethod])

    if (sherlockSubId === "invalid") {
        return <PageNotAccessable />
    } else {
        return (
            <div className={`flex ${Theme.Colors.DarkWebBg}`} onLoad={() => {
                if (Object.keys(sightings).length !== 0 || Object.keys(iocs).length !== 0) return

                dispatch(activateFullScreenPrompt("loading"))

                getPagedSherlockData(msalInstance, "indicators").then((response) => {
                    dispatch(setPagedIOCs(response.data))
                }).catch(() => {
                    dispatch(activateFullScreenPrompt("error"))
                })

                getPagedSherlockData(msalInstance, "sightings").then((response) => {
                    dispatch(setPagedSightings(response.data))
                    dispatch(activateFullScreenPrompt("false"))
                }).catch(() => {
                    dispatch(activateFullScreenPrompt("error"))
                })

                getSherlockMetrics(msalInstance, "total_counts").then((response) => {
                    dispatch(setSherlockTotalCounts(response.data))
                }).catch((err) => { console.error("Error fetching total counts", err) })

                getSherlockMetrics(msalInstance, "daily_metrics").then((response) => {
                    dispatch(setSherlockDailyMetrics(response.data))
                }).catch((err) => { console.error("Error fetching daily metrics", err) })

                getSherlockMetrics(msalInstance, "weekly_metrics").then((response) => {
                    dispatch(setSherlockWeeklyMetrics(response.data))
                }).catch((err) => { console.error("Error fetching weekly metrics", err) })

                getSherlockMetrics(msalInstance, "iocs_ranks").then((response) => {
                    dispatch(setLastWeekIOCsRank(response.data.last_week));
                    dispatch(setLastMonthIOCsRank(response.data.last_month));
                }).catch((err) => { console.error("Error fetching IOC rank metrics", err) })
            }}>
                <MenuBar onPage="sherlock" />
                <div className="w-full flex flex-col items-center min-h-screen pl-36 bg-cover" style={{ backgroundImage: `url(${SherlockBackground})` }} >
                    <div className="pt-2"></div>
                    {activeTab === "sightings" &&
                        <>
                            <SightingsLayout />
                        </>
                    }
                    {activeTab === "iocs" &&
                        <>
                            <IOCLayout />
                        </>
                    }
                </div>
            </div>
        )
    }
}

export default SherlockPage